// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__17D5i","showMessage":"showMessage__wCixr","history":"history__3BXbP normal__17D5i","typing":"typing__Ygve6 normal__17D5i","ava":"ava__2Gzoh","ava_image":"ava_image__VYJY6","message":"message__2cJI6","animated":"animated__3ZpEu message__2cJI6","text":"text__2xD4L","date":"date__23_lE","animateMessage":"animateMessage__39tVS"};


//////////////////
// WEBPACK FOOTER
// ./components/ChatBot/styles/message.scss
// module id = f8jX
// module chunks = 0